import { List } from "immutable";

import VocabularySpec from "seneca-common/features/assignments/state/models/spec/VocabularySpec";

export function getWordIds(spec: VocabularySpec): List<string> {
  return spec.wordIds;
}
